import { FC } from "react";
import { Typography } from "@jobber/components/Typography";
import styles from "./AppLogo.module.scss";

type AppLogo = {
  logo: string;
  title?: string;
};

const Logo: FC<AppLogo> = ({ logo, title="Jobber Channels — Instagram" }) => {
  return (
      <div className={styles.logo}>
          <img src={logo} alt="app logo"/>
          <Typography textColor={"white"} size={"jumbo"} fontWeight={"black"}>{title}</Typography>
      </div>
  );
};

export default Logo;
